import React, { useEffect, useState } from "react";
import CompletedLotsTable from "../table/CompletedLotsTable";
import { Modal } from "react-materialize";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { postAuctionReportWithAcceptedBySeller, postAuctionReportWithRejectedBySeller } from "../../../../redux/action/auctionReport";
import ReportModalContent from "../children/ReportModalContent";

function AuctionReportApproval({ singleAuctionData, loading }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [rejectedOffers, setRejectedOffers] = useState([]);
  const [acceptedOffers, setAcceptedOffers] = useState([]);
  const [proceedAuctionReport, setProceedAuctionReport] = useState(false);
  const [reasonOfRejectionLots, setReasonOfRejectionLots] = useState("");
  const [isAcceptedModalOpen, setIsAcceptedModalOpen] = useState(false);
  const { reportLoading } = useSelector((state) => state.auctionReport);

  const closeModal = (setModal) => setModal(false);

  const convertOffersToArrayOfObj = (offers) => {
    return offers.map((offerId) => ({ offer: offerId }));
  };

  const searchOrganizationIdWithOfferId = async (offerId) => {
    const modifyArrayOfObject = await singleAuctionData?.offers?.filter((offer) => offerId.includes(offer._id))
      .map((offer) => ({
        organizationId: offer?.bids?.[offer?.bids?.length - 1]?.organization,
        offerId: offer?._id,
      }));
    return modifyArrayOfObject;
  }

  const handleSubmitAuctionReport = async () => {
    const acceptedDetails = await searchOrganizationIdWithOfferId(acceptedOffers);
    if (acceptedOffers?.length === singleAuctionData?.offers?.length) {
      dispatch(
        postAuctionReportWithAcceptedBySeller(
          id,
          acceptedDetails,
          setIsAcceptedModalOpen,
          setAcceptedOffers,
          setRejectedOffers,
        )
      );
    } else {
      dispatch(
        postAuctionReportWithRejectedBySeller(
          id,
          acceptedDetails,
          convertOffersToArrayOfObj(rejectedOffers),
          reasonOfRejectionLots,
          setIsAcceptedModalOpen,
          setAcceptedOffers,
          setRejectedOffers,
        )
      );
    }

  };

  useEffect(() => {
    if (!isAcceptedModalOpen) {
      setProceedAuctionReport(false);
    }
  }, [isAcceptedModalOpen]);

  const isDisabled = () => {
    if (
      acceptedOffers?.length + rejectedOffers?.length !==
      singleAuctionData?.offers?.length
    ) {
      return true;
    }
    return false;
  };

  return (
    <div className="flex column gap-10px">
      <CompletedLotsTable
        offers={singleAuctionData?.offers}
        loading={loading}
        setAcceptedOffers={setAcceptedOffers}
        setRejectedOffers={setRejectedOffers}
        startingPriceApproval={
          singleAuctionData?.startingPriceApproval?.status === "approval"
        }
        lotApproved={
          singleAuctionData?.auctionReport &&
            (singleAuctionData?.auctionReport?.rejectedOffers?.length > 0 ||
              singleAuctionData?.auctionReport?.acceptedOffers?.length > 0)
            ? singleAuctionData?.auctionReport
            : false
        }
      />
      {(!singleAuctionData?.auctionReport ||
        singleAuctionData?.auctionReport?.rejectedOffers?.length === 0 ||
        singleAuctionData?.auctionReport?.acceptedOffers?.length === 0) && (
          <div className="flex justify-center gap-1">
            <button
              className={`button-style pointer font-16px ${isDisabled() ? "grey lighten-2" : "white-text cercle-purple"
                }`}
              style={{ padding: "10px 25px" }}
              onClick={() => setIsAcceptedModalOpen(true)}
              disabled={isDisabled()}
            >
              Submit
            </button>
          </div>
        )}

      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        style={styles.modal}
        className="modelAccount"
        id="modalView-details"
        open={isAcceptedModalOpen}
        options={{ onCloseEnd: () => closeModal(setIsAcceptedModalOpen) }}
      >
        <ReportModalContent
          isAccepted={true}
          acceptedOffers={acceptedOffers}
          rejectedOffers={rejectedOffers}
          setIsAcceptedModalOpen={setIsAcceptedModalOpen}
          setProceedAuctionReport={setProceedAuctionReport}
          proceedAuctionReport={proceedAuctionReport}
          singleAuctionData={singleAuctionData}
          setReasonOfRejectionLots={setReasonOfRejectionLots}
          reasonOfRejectionLots={reasonOfRejectionLots}
          handleSubmitAuctionReport={handleSubmitAuctionReport}
          reportLoading={reportLoading}
        />
      </Modal>
    </div>
  );
}
const styles = {
  modal: {
    maxHeight: "1000px",
  },
};
export default AuctionReportApproval;
